import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import useStateRef from 'react-usestateref';
import Helper from '../Helper';
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
import { useDispatch, useSelector } from 'react-redux';
import { includeQuickViewAddToCartDetailsAction } from '../../middleware/includeQuickViewAddToCartDetailsAction';

const AddToCartSuccessModal = (props) => {
	const history = useHistory();
	const [siteSpecDetails, setSiteSpecDetails, siteSpecDetailsRef] = useStateRef()
	const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef()
	const [count, setCount] = useState(1);
  	const [productName, setProductName, productNameRef] = useStateRef()
  	const [productId, setProductId, productIdRef] = useStateRef();
	const productDetails = useSelector(state => state.includeQuickViewAddToCartDetails.addedProductDetails)
	const dispatch = useDispatch();
	const handleGoToCart = () => {
		history.push("/checkout/cart");
	}

	function handleModalclose() {
		document.getElementById("cartAddModalClose").click();

	}
	function handleCustomerAlsoBought(productId) {
		// sitespec call
		var product = [];
		product.push(productId)
		var valueArrayOne = [];
		valueArrayOne.push("20501")
		const ruleArray = {
			name: "cbsParentCategory",
			bias: 0,
			values: valueArrayOne
		}
		var rule = [];
		rule.push(ruleArray)
		const map = {
			algorithm: "complementary",
			itemSet: product,
			num: 10,
			rules: rule
		}
		const inputMap = {
			spectMap: map
		}
		console.log("map", map);
		siteSpec(inputMap)
	}



	async function siteSpec(inputMap) {
		var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/sitespect-details`

		var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))

		setSiteSpecDetails(res.response)
		console.log("resfromSpec",siteSpecDetailsRef.current,"screenwidth==",screenWidthRef.current);
	}

	function replaceImage(event) {
		event.target.src = DEFAULT_IMAGE_140;

	}
	useEffect(() => {
		setScreenWidth(screen.width)
		handleFormEmpty()
	}, [])

	function handleFormEmpty(e) {
		console.log("handleFormEmpty called..");
		if (document.querySelector('#addToCartSuccess')) {
			document.querySelector('#addToCartSuccess').addEventListener('hidden.bs.modal', function (e) {
				dispatch(includeQuickViewAddToCartDetailsAction(''));
				setProductId()
		setProductName()
		setCount(1)
		if(props.setIsProductChanged){
			props.setIsProductChanged(false);
		}
		if(props.setTriggerModal){
			props.setTriggerModal(false);
			console.log("triggerModal is false...");
		}
	})
			console.log("Modal details resetted...");
		}
	}
	useEffect(() => {
		handleCustomerAlsoBought(props.productId)
		setSiteSpecDetails()
		console.log("useeffect success modal",props);
		if(productDetails){
			console.log('productDetails in success modal....',productDetails);
			setProductId(productDetails?.productId ? productDetails?.productId : '')
			setProductName(productDetails?.productName ? productDetails?.productName :'')
			setCount(productDetails?.quantity ? productDetails?.quantity : '')
		}else{
			console.log('productDetails in else condition...',props.productId, props.productName, count);
			setProductId(props.productId)
			setProductName(props.productName)
			props.quantity && setCount(props.quantity)
		}
		console.log("productId====",productIdRef.current,"==productName===",productNameRef.current,"===count===",count);
	}, [props.productId, props.isProductChanged, props.actionToggle])
	return (
		<div className="modal fade c-modal-style show" id="addToCartSuccess" tabindex="-1" aria-labelledby="addToCartSuccessLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
				<div className="modal-content ">
					<button id="cartAddModalClose" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					<div className="modal-body modalCartPadding">
						<div class="container-fluid cart-modal">
							<div className="row">
								<div class="col-12 col-lg-6 container-fluid cart-modal ss-modified-4" data-ss-variation-applied="1">
									{/* <div class="row">
										<div class="col-12 col-lg-12"> */}
									<div class="row align-items-center add-cart-container">
										<div class="col-auto add-to-cart-title">
											<h5 class="modal-title" id="defaultModalLabel" style={{color: "#000"}}>Added to Cart:</h5>
										</div>
										<div class="col-12 col-md-auto order-3 order-lg-2 px-lg-0 success-modal-action">
											<button role="button" class="btn-primary quick-hover-btn go-to-cart-btn" data-bs-dismiss="modal" onClick={handleGoToCart}>Go to Cart</button>
											<button role="button" class="btn-primary quick-hover-btn continue-shop-btn" data-bs-dismiss="modal">Continue Shopping</button>
										</div>
										<ul class="col-12 order-2 order-lg-3 cart-added-items cart-success-detail list-unstyled">
											<li class="row g-0">
												<div class="col added-item-content">
													<span dangerouslySetInnerHTML={{ __html:  productDetails?.productName ? productDetails?.productName : props.productName ? props.productName : "" }}></span>
												</div>
												<div class="added-item-label added-item-detail">
													{console.log('count & productId & productName in return...', count, productIdRef.current, productNameRef.current)}
													<span class="fwb">Item # { productDetails?.productId ? productDetails?.productId : props.productId ? props.productId : ""}</span>
													<span class="item-qty">Qty: { count ? count:1}</span>
												</div>

											</li>
										</ul>
									</div>
									{/* </div>
									</div> */}
								</div>
								{screenWidthRef.current > 1024 ?
								<div className='col-12 col-lg-6 cust-recommend d-none d-md-block'>
									{console.log("inside return statement",siteSpecDetailsRef.current)}
									{siteSpecDetailsRef.current ?


										<div class="cart-container-right mb-5">

											<h6 class="h6">
												Customers Also Bought...
											</h6>
											<div class="row category-grid row-cols-3">


												{siteSpecDetailsRef.current.map((value, index) => {

													return (<>
														{index < 3 ?
															<div className="">
																<Link className='w-100 cb-product-link' to={value && value.variantUrl && value.variantUrl.productUrl} onClick={() => handleModalclose()}>
																	<div className='justify-content-center d-flex'>
																		<img fetchpriority="high" className='img-fluid' onError={replaceImage} src={value && value.variantUrl && value.variantUrl.imageURL} alt={value && value.variantUrl && value.variantUrl.imageURL} />
																	</div>
																	<h3 className=" my-2 cb-categoryName-title" dangerouslySetInnerHTML={{ __html: value && value.variantUrl && value.variantUrl.displayName }}></h3>
																</Link>
																<p class="c-product-total">Item #{value && value.variantUrl && value.variantUrl.skuId}</p>
																{value && value.hidePrice && value.hidePrice == "true" ?
																	<p class="c-product-price">
																		Call For Pricing
																	</p> : <p className="my-0 cb-productPrice">{value && value.variantUrl && value.variantUrl.itemPrice}</p>}
																{value && value.reviewURLAverage ?
																	<div class="cb-product-rating">
																		<img fetchpriority="high" src={`/images/stars/50/rating-${value.reviewURLAverage}_50.png`} alt="rating" />
																	</div>

																	: ""}
																{value && value.variantUrl && value.variantUrl.qtyDiscountAvailable && value.variantUrl.qtyDiscountAvailable == true ?
																	<p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}


															</div> : ""}
													</>)
												})}


											</div>
										</div>


										: ""}
								</div>:""}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AddToCartSuccessModal
